import React from 'react';
import './HintSection.css';
import HintText from './HintText';

const HintSection = ({
  placedWords,
  currentHintIndex
}) => {
  // Guarded because this indexes placedWords directly. Generation used to be
  // synchronous so the array was always populated by first paint; now that the
  // puzzle arrives over the network, an unguarded index here is a white screen.
  const definition = placedWords?.[currentHintIndex]?.definition;
  if (!definition) return null;

  return (
    <div className="hint-section">
      <div className="top-row">
      </div>
      <div className="controls-row">
        <HintText definition={definition} />
      </div>
    </div>
  );
};

export default HintSection; 